'use client';

import React from 'react';
import HeroSection from './HeroSection';
import MissionSection from './MissionSection';
import LeadershipSection from './LeadershipSection';
import TimelineSection from './TimelineSection';
import RecognitionSection from './RecognitionSection';
import CultureSection from './CultureSection';
import StandardsFAQSection from './StandardsFAQSection';
import CareersSection from './CareersSection';
import CTASection from './CTASection';
import Footer from '@/app/homepage/components/Footer';

const AboutInteractive = () => {
  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
      <MissionSection />
      <LeadershipSection />
      <TimelineSection />
      <RecognitionSection />
      <CultureSection />
      <StandardsFAQSection />
      <CareersSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default AboutInteractive;